import { jsxs as l, jsx as e } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ l(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_864_10169)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
            fill: "#F3F3FD"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M61.5336 63.2278C68.4191 63.2278 73.998 57.3856 73.998 50.1821C73.998 42.976 68.4191 37.1338 61.5336 37.1338H51.3306",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M38.4625 37.3047C31.5769 37.3047 25.998 43.1469 25.998 50.3504C25.998 57.5565 31.5769 63.3987 38.4625 63.3987H48.6655",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M43.3311 52.5293L56.3822 63.398L43.3311 74.2668V52.5293Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M43.3311 52.5293L56.3822 63.398L43.3311 74.2668V52.5293Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M56.6649 48.0041L43.6138 37.1353L56.6649 26.2666V48.0041Z",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M56.6649 48.0041L43.6138 37.1353L56.6649 26.2666V48.0041Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinejoin: "round"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_864_10169", children: /* @__PURE__ */ e("rect", { width: "100", height: "100", fill: "white" }) }) })
    ]
  }
);
export {
  r as RestartIllustration
};
//# sourceMappingURL=index.es471.js.map
